import { Dispatch, SetStateAction, useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { DeleteModal } from '@makyoapp/makyo-ui'

import { toasted } from '@/lib/toast'
import { useReqError } from '@/hooks/useReqError'
import { useGridV2Context } from '@/components/GridV2/contexts/GridV2Context'

interface ModalClearRowsProps {
  show: boolean
  setShow: Dispatch<SetStateAction<boolean>>
}

export function ModalClearRows({ show, setShow }: ModalClearRowsProps) {
  const { activeTable } = useGridV2Context()
  const { t } = useTranslation()
  const [isLoading, setIsLoading] = useState(false)

  const reset = () => {
    setIsLoading(false)
    setShow(false)
  }

  const printAPIError = useReqError()

  return (
    <DeleteModal
      show={show}
      onHide={reset}
      withCancel
      isLoading={isLoading}
      onSubmit={() => {
        setIsLoading(true)
        activeTable
          ?.ClearRows()
          .then(() => {
            setTimeout(() => {
              window.dispatchEvent(new CustomEvent('db-client-reload'))
              toasted(t('Rows Cleared'))
            }, 500)
          })
          .catch(printAPIError)
          .finally(() => reset())
      }}
      title={t('Delete all rows, keep the columns')}
    >
      <div className='modal-md'>
        <div>
          <Trans>Are you sure you would like to clear all rows? this action is irreversible</Trans>
        </div>
      </div>
    </DeleteModal>
  )
}
